import { createStyles, makeStyles } from '@material-ui/core/styles';
import { colors } from './colors';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      html: {
        '-webkit-font-smoothing': 'antialiased',
        fontFamily: 'Roboto, sans-serif',
      },
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      '*::before, *::after': {
        boxSizing: 'inherit',
      },
      body: {
        fontSize: '1.4rem',
        background: colors.white,
      },
    },
  }),
);

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
